import { TFunction } from 'i18next';

import { MarkAreaColor, MarkAreaHoverColor } from '../../../../src/enums';
import { NOPStrategyItems } from '../../../shared/types';
import { nopStrategyMarkAreaDateItem } from '../../../types';
import { getActiveStrategyByName } from '../PriceViewer';
import {
  DataSetSeriesGenerator,
  getDefaultToolptipFormatter,
  PriceViewerSeries,
} from './base';
import { getSignalTranslateCode } from './NOPStrategySignal';
class NOPStrategySignalArea extends DataSetSeriesGenerator {
  isSeparateFromPriceChart = false;
  shareYAxisWithPriceChart = true;
  activeStrategy: string;

  nopStrategy: readonly NOPStrategyItems[];

  constructor(
    nopStrategy: readonly NOPStrategyItems[],
    activeStrategy: string,
    t: TFunction
  ) {
    super(t);
    this.nopStrategy = nopStrategy;
    this.activeStrategy = activeStrategy;
  }

  getChartName(): string {
    return this.activeStrategy + ' ' + this.t('strategy-signal');
  }
  getMarkAreaDate(
    strategySignalData: string[][]
  ): nopStrategyMarkAreaDateItem[][] {
    const markAreaDate = [];
    let eachMarkAreaDateArray = [];
    let firstSignal = true;
    for (const [
      index,
      [signalDate, strategySignal],
    ] of strategySignalData.entries()) {
      let color = MarkAreaColor.buy;
      let hoverColor = MarkAreaHoverColor.buy;
      if (firstSignal === true && strategySignal !== undefined) {
        color = MarkAreaColor.longPosition;
        hoverColor = MarkAreaHoverColor.longPosition;
        eachMarkAreaDateArray.push({
          xAxis: signalDate,
          emphasis: {
            itemStyle: {
              color: hoverColor,
            },
          },
          itemStyle: {
            color: color,
          },
        });
        firstSignal = false;
      }

      if (['Flat Long Position', 'Break_mdd'].includes(strategySignal)) {
        color = MarkAreaColor.longPosition;
        hoverColor = MarkAreaHoverColor.longPosition;
      } else if (strategySignal === 'Sell') {
        color = MarkAreaColor.sell;
        hoverColor = MarkAreaHoverColor.sell;
      }
      if (strategySignal !== 'Hold' && strategySignal) {
        if (eachMarkAreaDateArray.length > 0) {
          eachMarkAreaDateArray.push({
            xAxis: signalDate,
          });
          markAreaDate.push(eachMarkAreaDateArray);
          eachMarkAreaDateArray = [];
        }
        eachMarkAreaDateArray.push({
          xAxis: signalDate,
          itemStyle: {
            color: color,
          },
          emphasis: {
            itemStyle: {
              color: hoverColor,
            },
          },
        });
      }
      if (index === strategySignalData.length - 1 && strategySignal) {
        eachMarkAreaDateArray.push({
          xAxis: signalDate,
        });
        markAreaDate.push(eachMarkAreaDateArray);
      }
    }
    return markAreaDate;
  }
  getSignal(
    nopStrategydata: readonly NOPStrategyItems[],
    strategy: string
  ): string[][] {
    const strategySignalDate = [];
    let previousSignal = 'Hold';
    for (const item of nopStrategydata) {
      let signal = item[strategy + '_signal'];
      if (previousSignal !== signal && (signal === 'Hold' || !signal)) {
        signal = previousSignal;
      }
      strategySignalDate.push([
        item['date'],
        this.t(getSignalTranslateCode(signal)),
      ]);
      if (signal) {
        previousSignal = signal;
      }
    }
    return strategySignalDate;
  }
  getSeries(): PriceViewerSeries {
    const strategy = getActiveStrategyByName(this.activeStrategy);
    const strategySignalData: string[][] = this.nopStrategy.map(item => [
      item['date'],
      item[strategy + '_signal'],
    ]);
    const series: echarts.EChartOption.SeriesLine = {
      type: 'line',
      data: this.getSignal(this.nopStrategy, strategy),
      symbol: 'none',
      lineStyle: {
        color: 'rgba(255,255,255,0)',
      },
      markArea: {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        data: this.getMarkAreaDate(strategySignalData),
      },
    };
    return {
      name: this.getChartName(),
      echartSeries: series,
      tooltipFormatter:
        strategySignalData.length === 0 || !strategySignalData.at(-1)[1]
          ? null
          : getDefaultToolptipFormatter('2d', 'number', {
              keyColor: '#003366',
            }),
    };
  }
}

export default NOPStrategySignalArea;
